module.exports = __webpack_public_path__ + "static/coopfond-238558b831994b5a43acfa6ad6164960.jpg";